import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建池子 ")
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("现金")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("积分")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("军粮")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("草稿")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("上线")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("统计")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("模拟")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_SimulationModal = _resolveComponent("SimulationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "池子名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "草稿",
                    value: "draft"
                  }),
                  _createVNode(_component_el_option, {
                    label: "上线",
                    value: "active"
                  }),
                  _createVNode(_component_el_option, {
                    label: "下架",
                    value: "archived"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "box_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.box_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.box_type) = $event)),
                placeholder: "价格类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "现金",
                    value: "cash"
                  }),
                  _createVNode(_component_el_option, {
                    label: "积分",
                    value: "membership_point"
                  }),
                  _createVNode(_component_el_option, {
                    label: "军粮",
                    value: "extra_point"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'match_pools_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          title: "图片",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.image,
                  "preview-src-list": [row.image],
                  fit: "cover",
                  style: {"width":"50px","height":"50px"}
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "价格",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.box_type === 'cash')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(Number(row.price).toFixed(2)) + "元", 1))
              : (row.box_type === 'membership_point')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.price) + "积分", 1))
                : (row.box_type === 'extra_point')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row.price) + "军粮", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.price), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "价格类型",
          width: "90"
        }, {
          default: _withCtx(({ row }) => [
            (row.box_type === 'cash')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : (row.box_type === 'membership_point')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }))
                : (row.box_type === 'extra_point')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "info",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "赏品/场上",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.item_count) + " / " + _toDisplayString(row.field_size), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 'draft')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : (row.status === 'active')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : (row.status === 'archived')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, { title: "测试" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: row.is_test ? 'red' : '' })
            }, _toDisplayString(row.is_test ? '是' : ''), 5)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "280",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'match_pools_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "info",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'match_pools_stats', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "warning",
              size: "small",
              onClick: ($event: any) => (_ctx.onSimulate(row))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDelete(row)),
              disabled: row.status === 'active'
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_SimulationModal, {
      visible: _ctx.simulationDialogVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.simulationDialogVisible) = $event)),
      "match-pool": _ctx.currentPool,
      onSimulated: _ctx.onSimulated
    }, null, 8, ["visible", "match-pool", "onSimulated"])
  ]))
}